/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class IcalFixturesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get iCal fixture
     * Serve static iCal fixtures for local and test environments
     * @param fixture
     * @returns string
     * @throws ApiError
     */
    public getIcalFixture(
        fixture: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ical-fixtures/{fixture}',
            path: {
                'fixture': fixture,
            },
        });
    }
}
